import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react"
import { setupSessionInterceptors } from './utils/sessionManager';

// Setup session interceptors
setupSessionInterceptors();


const config = {
  apiKey: "hbp_rFaAgcZD9xarLPATcHlh3uGAbL4lWy2UyqOi",
  environment: "production"
}

const honeybadger = Honeybadger.configure(config)


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Caught error:', error, errorInfo);
   }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontFamily: 'sans-serif'
        }}>
          <h2>Something went wrong.</h2>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#297934',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Wrap App with ErrorBoundary
const AppWithErrorBoundary = () => (
  <React.StrictMode>
    <HoneybadgerErrorBoundary honeybadger={honeybadger}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HoneybadgerErrorBoundary>
  </React.StrictMode>
);

ReactDOM.render(
  <AppWithErrorBoundary />,
  document.getElementById('root')
);

reportWebVitals();
